export default "__VITE_ASSET__B3EQNCz6__"